import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { LocationUtils } from '@/utils/auth/location.utils';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { useEffectExceptOnMount } from '@/hooks/useEffectExceptOnMount.hook';
import { browserHistory } from './browserHistory';
import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import { EnvUtils } from '@/utils/env.utils';
import { notificationService } from '@/services/notification/notification.client';
import { useGetApplicationSubscriptionName } from '@/hooks/identity/useGetApplicationSubscriptionName';

export function useWorkspaceLocationSynchronization() {
  const location = useLocation();
  const { getApplicationSubscriptionName } = useGetApplicationSubscriptionName();
  const [subscriptionName, setSubscriptionName] = useState<string>();

  const setLocationWithSubscriptionName = async (currentUrl: string) => {
    try {
      const userId = await LocationUtils.getUserId();
      const subscriptionId = await getSubscriptionId();
      if (userId && subscriptionId && !EnvUtils.isDevelopment()) {
        const applicationSubscriptionName = await getApplicationSubscriptionName();
        setSubscriptionName(applicationSubscriptionName);
      }

      if (subscriptionName) {
        LocationUtils.setCurrentLocationToWorkspace(currentUrl, subscriptionName);
      }
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    const redirectToUrlFromWorkspace = async () => {
      try {
        const currentUrlInstance = new URL(window.location.href);
        const pathNameTrimmed = currentUrlInstance.pathname.includes('//') ? currentUrlInstance.pathname.slice(1) :
          currentUrlInstance.pathname;
        const currentUrlLink = currentUrlInstance.origin + pathNameTrimmed + currentUrlInstance.search;

        const currentWorkspaceUrl = new URL(await LocationUtils.getWorkspaceUrl());
        const workspaceLocationLink = currentWorkspaceUrl.searchParams.get('location') ?? '';

        if (workspaceLocationLink && workspaceLocationLink !== currentUrlInstance.href) {
          const pathToRedirect = new URL(currentUrlLink);
          const parameterizedLink = getParameterizedLink(pathToRedirect.pathname + pathToRedirect.search);
          browserHistory.push(parameterizedLink);
        }
        else {
          setLocationWithSubscriptionName(currentUrlLink);
        }
      }
      catch (err) {
        console.error(err);
        notificationService.open({
          title: 'Error',
          text: 'Can\'t get location from workspace',
          type: 'danger'
        });
      }
    };

    redirectToUrlFromWorkspace();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionName]);

  useEffectExceptOnMount(() => {
    const urlInstance = new URL(window.location.href);
    setLocationWithSubscriptionName(urlInstance.href);

  }, [location]);
}
